import { useApp } from "@/context/AppContext";
import { Header } from "@/components/Header";
import client from "@/api";
import { toast } from "sonner";
import { Link2, Check, ShieldCheck } from "lucide-react";

export default function Profile() {
  const { t, user, checkAuth } = useApp();
  if (!user) return null;
  const has = (p) => user.providers?.includes(p);

  const linkGoogle = () => {
    localStorage.setItem("linkIntent", "google");
    const redirectUrl = window.location.origin + "/profile";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0d0d0d] bg-grain">
      <Header />
      <main className="max-w-2xl mx-auto px-4 sm:px-8 py-10">
        <h1 className="font-serif text-3xl text-[#FFFFFF] mb-8" data-testid="profile-title">{t("profile")}</h1>

        <div className="card-dark rounded-2xl p-6 mb-6">
          <div className="flex items-center gap-4">
            {user.picture ? <img src={user.picture} alt="" className="w-14 h-14 rounded-full" /> :
              <div className="w-14 h-14 rounded-full bg-[#D21F2A]/20 flex items-center justify-center font-serif text-xl text-[#D21F2A]">{user.name?.[0]}</div>}
            <div>
              <div className="text-[#FFFFFF] font-medium">{user.name}</div>
              <div className="text-sm text-[#9AA0A6]">{user.email}</div>
            </div>
          </div>
        </div>

        <div className="card-dark rounded-2xl p-6" data-testid="linked-providers">
          <div className="flex items-center gap-2 mb-4"><Link2 className="w-5 h-5 text-[#D21F2A]" />
            <h2 className="font-serif text-xl text-[#FFFFFF]">{t("linked_accounts")}</h2></div>
          <p className="text-xs text-[#9AA0A6] mb-4">{t("link_note")}</p>

          <div className="space-y-3">
            <div className="flex items-center justify-between px-4 py-3 rounded-xl bg-[#141414] border border-[#D21F2A]/10">
              <span className="text-[#FFFFFF]">Google</span>
              {has("google") ? <span className="inline-flex items-center gap-1 text-[#6EE7B7] text-sm"><Check className="w-4 h-4" /> {t("linked")}</span> :
                <button data-testid="link-google-btn" onClick={linkGoogle} className="btn-gold focusable text-sm px-4 py-2 rounded-lg">{t("link_now")}</button>}
            </div>
          </div>
          <p className="text-xs text-[#9AA0A6] mt-4 flex items-start gap-1"><ShieldCheck className="w-3.5 h-3.5 mt-0.5 shrink-0" />{t("link_security")}</p>
        </div>
      </main>
    </div>
  );
}
